var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index"},[_c('navmen',{on:{"showChoseType":_vm.showChoseType}}),_c('div',{staticClass:"rightContainer"},[_c('router-view')],1),(_vm.footShow)?_c('pagefoot'):_vm._e(),_c('changeusertype',{attrs:{"changeUserTypeDialogVisible":_vm.choseUserTypeShow},on:{"closeChoseTypePop":_vm.choseUserTypeClose}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }